import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCrown"><Path d="M12.0014 2.37939L7.51374 9.24295L0.679688 5.25641L3.7021 19.9999H20.3008L23.3232 5.25641L16.4892 9.24295L12.0014 2.37939Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrown;
